// Source-document categories from the Chris walkthrough, 00:39:00–00:41:32.
// SOURCE_ kinds distinguish customer evidence from generated or approved legal output.
export const sourceDocumentGroups = [
  { label: 'Common job documents', types: [
    ['NOTICE_OF_COMMENCEMENT', 'Notice of Commencement (NOC)'],
    ['BUILDING_PERMIT', 'Building permit'], ['BOND', 'Payment / performance bond'],
    ['CONTRACT', 'Contract'], ['PURCHASE_ORDER', 'Purchase order'], ['ESTIMATE', 'Estimate'],
    ['INVOICE', 'Invoice'], ['STATEMENT', 'Statement'], ['PLANS', 'Plans / site plan'],
  ] },
  { label: 'Property and research', types: [
    ['WARRANTY_DEED', 'Warranty deed'], ['CONDO_DECLARATION', 'Declaration of condominium'],
    ['PROPERTY_LEGAL_DESCRIPTION', 'Property legal description'], ['RESEARCH', 'Research report'],
    ['CUSTOMER_RESEARCH', 'Customer research file'], ['CUSTOMER_CORRECTION', 'Customer file correction'],
    ['BATCH_DATA', 'Customer batch data file'], ['JOB_SUMMARY', 'Original job summary'],
  ] },
  { label: 'Recorded documents', types: [
    ['RECORDED_NOC', 'Recorded Notice of Commencement'], ['RECORDED_LIEN', 'Recorded lien'],
    ['RECORDED_PARTIAL_SATISFACTION', 'Recorded partial satisfaction'],
    ['RECORDED_SATISFACTION', 'Recorded satisfaction'], ['RECORDED_LEASE', 'Recorded lease'],
    ['RECORDED_RELEASE', 'Recorded release of lien'], ['RECORDED_INTENT_TO_LIEN', 'Recorded intent to lien'],
    ['RECORDED_TERMINATION', 'Recorded notice of termination'],
  ] },
  { label: 'Notices, bonds and other supporting records', types: [
    ['PRELIMINARY_NOTICE', 'Preliminary notice'], ['LIEN_AGENT_NOTICE', 'Notice to lien agent'],
    ['BOND_CLAIM', 'Claim on bond'], ['BOND_WAIVER', 'Waiver on bond'],
    ['CONTRACTOR_FINAL_AFFIDAVIT', 'Contractor’s final affidavit'], ['RETURNED_MAIL', 'Returned mail'],
    ['BUSINESS_LICENSE', 'Business license'], ['GOOD_STANDING', 'Certificate of good standing'],
  ] },
  { label: 'Notarized documents', types: [
    ['NOTARIZED_THIRD_MONTH_BOND_CLAIM', 'Notarized third-month bond claim'],
    ['NOTARIZED_BOND', 'Notarized bond'], ['NOTARIZED_INTENT_TO_LIEN', 'Notarized intent to lien'],
    ['NOTARIZED_LIEN', 'Notarized lien'], ['NOTARIZED_SATISFACTION', 'Notarized satisfaction'],
    ['NOTARIZED_PRELIMINARY_NOTICE', 'Notarized preliminary notice'],
    ['NOTARIZED_PARTIAL_SATISFACTION', 'Notarized partial satisfaction'],
    ['NOTARIZED_STOP_PAYMENT', 'Notarized stop-payment'],
    ['NOTARIZED_CONTRACTOR_FINAL_AFFIDAVIT', 'Notarized contractor’s final affidavit'],
    ['NOTARIZED_NOC', 'Notarized Notice of Commencement'],
  ] },
] as const;
export const sourceDocumentKinds = new Map<string, string>(sourceDocumentGroups.flatMap(group => group.types.map(([key, label]) => [`SOURCE_${key}`, label] as [string, string])).concat([['SUPPORTING_FILE', 'Other supporting document']]));
export function sourceDocumentLabel(kind: string) {
  return sourceDocumentKinds.get(kind) ?? kind.charAt(0) + kind.slice(1).toLowerCase().replaceAll('_', ' ');
}
